import React, { useEffect, useState } from 'react';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeHash, setActiveHash] = useState('#home');

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const syncHash = () => {
      setActiveHash(window.location.hash || '#home');
    };

    syncHash();
    window.addEventListener('hashchange', syncHash);
    return () => window.removeEventListener('hashchange', syncHash);
  }, []);

  const linkBaseClasses =
    "transition-colors duration-200 text-sm font-medium hover:text-sky-300";

  const getLinkClasses = (hash) =>
    `${linkBaseClasses} ${
      activeHash === hash ? "text-sky-300" : "text-slate-200"
    }`;

  const handleNavClick = (hash) => (e) => {
    e.preventDefault();
    setActiveHash(hash);
    closeMobileMenu();

    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.pushState(null, '', hash);
    }
  };

  return (
    <nav
      className="fixed top-0 z-20 w-full border-b border-slate-800 bg-black/70 backdrop-blur-md"
      style={{ cursor: "default" }}
    >
      <div className="mx-auto flex w-11/12 max-w-6xl items-center justify-between py-3">
        <div className="flex items-center gap-3">
          <a href="#home" onClick={handleNavClick('#home')} className="flex items-center gap-2">
            <img
              src="logo_home.png"
              alt="logo"
              className="h-9 w-9 rounded-full border border-slate-700 object-cover"
            />
            <span className="hidden text-sm font-semibold tracking-wide text-slate-100 sm:inline">
              Abhay
            </span>
          </a>
        </div>

        <div className="hidden items-center gap-6 sm:flex">
          <a href="#home" onClick={handleNavClick('#home')} className={getLinkClasses('#home')}>
            Home
          </a>
          <a href="#projects" onClick={handleNavClick('#projects')} className={getLinkClasses('#projects')}>
            Projects
          </a>
          <a href="#experience" onClick={handleNavClick('#experience')} className={getLinkClasses('#experience')}>
            Experience
          </a>
          <a href="#about" onClick={handleNavClick('#about')} className={getLinkClasses('#about')}>
            About
          </a>
          <a href="#contact" onClick={handleNavClick('#contact')} className={getLinkClasses('#contact')}>
            Contact
          </a>
        </div>

        <div className="flex items-center gap-3 sm:hidden">
          <button
            onClick={toggleMobileMenu}
            className="rounded-md border border-slate-700 bg-slate-900/60 px-3 py-1 text-sm text-slate-100 shadow-sm focus:outline-none"
          >
            {isMobileMenuOpen ? "Close" : "Menu"}
          </button>
        </div>

        <div
          className={`sm:hidden fixed inset-0 z-30 flex-col bg-black/90 backdrop-blur-sm transition-opacity duration-200 ${
            isMobileMenuOpen ? "flex" : "hidden"
          }`}
        >
          <button
            onClick={closeMobileMenu}
            className="absolute right-5 top-5 text-2xl text-slate-200 focus:outline-none"
          >
            ✕
          </button>
          <ul className="mt-24 flex flex-1 flex-col items-center justify-start gap-6 text-xl font-medium text-slate-100">
            <li>
              <a href="#home" onClick={handleNavClick('#home')} className="hover:text-sky-300">
                Home
              </a>
            </li>
            <li>
              <a href="#projects" onClick={handleNavClick('#projects')} className="hover:text-sky-300">
                Projects
              </a>
            </li>
            <li>
              <a href="#experience" onClick={handleNavClick('#experience')} className="hover:text-sky-300">
                Experience
              </a>
            </li>
            <li>
              <a href="#about" onClick={handleNavClick('#about')} className="hover:text-sky-300">
                About
              </a>
            </li>
            <li>
              <a href="#contact" onClick={handleNavClick('#contact')} className="hover:text-sky-300">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
